<template>
    <div class="modal" ref="masterClientModal" id="masterClientModal" role="dialog">
        <div class="modal-dialog modal-lg">
            <div class="modal-content">

                <div class="modal-header bg-teal text-white font-bold">
                    Update Master Company
                </div>

                <div class="modal-body bg-white">
                    <multiselect :options="contacts"
                        v-model="form.selected_contacts"
                        placeholder="Select the contacts..."
                        :show-labels="false"
                        :multiple="true"
                        :close-on-select="false"
                        :clear-on-select="false"
                        :preserve-search="true"
                        track-by="id"
                        :custom-label="contactAndCompanyString" class="mb-2 cursor-pointer">
                    </multiselect>
                    <div class="text-red text-xs" v-if="form.errors.has('selected_contacts')">{{
                        form.errors.get('selected_contacts') }}
                    </div>
                </div>

                <div class="modal-footer">
                    <button class="btn btn-primary" @click.prevent="massUpdate()">
                        Mass Update <i v-if="loadingUpdate" class="fa fa-spin fa-spinner" aria-hidden="true"></i>
                    </button>
                    <button class="btn btn-link" type="reset" data-dismiss="modal">
                        Close
                    </button>
                </div>

            </div>
        </div>
    </div>
</template>

<script>
import Form from "../../../utils/form";
import Multiselect from 'vue-multiselect';

export default {
    name: 'master-client',
    props: {
        checked_project_ids: { type: Array }
    },
    components: { Multiselect },

    data() {
        return {
            loadingUpdate: false,
            contacts: [],
            form: new Form({
                project_ids: [],
                selected_contacts: []
            })
        }
    },

    mounted() {
        $("#masterClientModal").on('hidden.bs.modal', () => this.clear());
    },

    methods: {
        open() {
            $(this.$el).modal('show');
            this.form.project_ids = [ ...this.checked_project_ids ];
            axios.get('/api/project/mass-update/companies/all-contacts')
                .then(({data}) => {
                    this.contacts = data.data;
                })
                .catch((err) => {
                    console.error(err);
                });
        },

        close() {
            $(this.$el).modal('hide');
            this.clear();
        },

        clear() {
            this.contacts               = [];
            this.form.project_ids       = [];
            this.form.selected_contacts = [];
        },

        massUpdate() {
            this.loadingUpdate = true;
            this.form.put('/api/project/mass-update/master-client')
                .then((data) => {
                    this.loadingUpdate = false;
                    this.close();
                    this.$emit('update-finished', data);
                })
                .catch((err) => {
                    this.loadingUpdate = false;
                    console.error(err);
                });
        },

        contactAndCompanyString(contact) {
            return `${contact.name} (${contact.title} at ${contact.company.name})`;
        },

        clearErrors() {
            this.form.errors.clear();
        }
    }
}
</script>

<style src="vue-multiselect/dist/vue-multiselect.min.css"></style>

